import { ID } from '@griply/types';

export const getCommonUIDs = (
  ...lists: (ID[] | undefined)[]
): ID[] | undefined => {
  const notEmptyLists = lists.filter((l) => l) as ID[][];
  if (!notEmptyLists.length) {
    return undefined;
  }

  if (notEmptyLists.length === 1) {
    return notEmptyLists[0];
  }

  const sets = notEmptyLists.slice(1).map((l) => new Set(l));
  return notEmptyLists[0].filter((uid) => sets.every((s) => s.has(uid)));
};
